import Api from '../../api/index'

const Form = {
  namespaced: true,
  state: {
    value: 'my value',

    oneForm: null, //to store SHOW response
    allForms: null, //to store SHOW response

    //promises results
    createFormWasGood: null,
    createFormMessage: null,
    
    updateFormWasGood: null,
    updateFormMessage: null,

     // less used
    indexFormWasGood: null,
    indexFormMessage: null,

    showFormWasGood: null,
    showFormMessage: null,
  },
  getters: {
    getStateValue: state => {
      return state.value;
    }
  },

  mutations: {
    setOneForm(state, Form){
      state.oneForm = Form.data.attributes // Form.data
    },
    setAllForms(state, Forms){
      Forms = Forms.data? Forms.data.map(obj=>obj.attributes) : Forms
      state.allForms = Forms
    },

    createResponse(state, {was_good, msg}){
      state.createFormWasGood = was_good
      state.createFormMessage = msg
      setTimeout(() => {
        state.createFormWasGood = null
      }, 100);
    },
    updateResponse(state, {was_good, msg}){
      state.updateFormWasGood = was_good
      state.updateFormMessage = msg
      setTimeout(() => {
        state.updateFormWasGood = null
      }, 100);
    },
    indexResponse(state, {was_good, msg}){
      state.indexFormWasGood = was_good
      state.indexFormMessage = msg
      setTimeout(() => {
        state.indexFormWasGood = null
      }, 100);
    },
    showResponse(state, {was_good, msg}){
      state.showFormWasGood = was_good
      state.showFormMessage = msg
      setTimeout(() => {
        state.showFormWasGood = null
      }, 100);
    },

    clearAllForms(state){
      state.allForms = null
    },
    clearOneForm(state){
      state.oneForm = null
    },
  },

  actions: {
    clearAllForms({commit}){
      commit('clearAllForms')
    },
    clearOneForm({commit}){
      commit('clearOneForm')
    },

    index(context, filter) {
      Api.Form.index(filter)
        .then(response => response.data)
        .then(Forms => {
          context.commit('setAllForms', Forms);
          context.commit('indexResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          // console.log({error});
          context.commit('indexResponse', {msg: error, was_good: false});
             // auto-comment// console.log(error);
        });
    },
    show(context, Form_id) {
      Api.Form.show(Form_id)
        .then(response => response.data)
        .then(Form => {
          context.commit('setOneForm', Form);
          context.commit('showResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('showResponse', {msg: error.response.data.errors[0], was_good: false});
             // auto-comment// console.log(error);
        });
    },
    create(context, new_Form) {
      return Api.Form.create(new_Form)
        .then(response => response.data)
        .then(Form => {
          // context.commit('setOneForms', Form); // not often used
          context.commit('createResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('createResponse', {msg: error.response.data.errors[0], was_good: false});
             // auto-comment// console.log(error);
        });
    },
    update(context, Form) {
      return Api.Form.update(Form)
        .then(response => response.data)
        .then(Form => {
          // context.commit('setOneForm', Form); // not often used
          context.commit('updateResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('updateResponse', {msg: error.response.data.errors[0], was_good: false});
             // auto-comment// console.log(error);
        });
    },
    delete(context, Form) {
      Api.Form.delete(Form)
        .then(response => response.data)
        .then(Form => {
          // context.commit('setOneForm', Form); // not often used
          // context.dispatch('Solution/removeDeletedForm', Form, {root: true})
          
          let notification = {
            type: 'success', // 'success
            msg: `Apagado com sucesso` // success msg
          }
          context.dispatch('Notification/add', notification, {root: true})

          // context.commit('updateResponse', {msg: 'Apagado com sucesso', was_good: true});
        }).catch(function(error) {
          let notification = {
            type: 'error', // 'success
            msg: `Erro: ${error}` // success msg
          }
          context.dispatch('Notification/add', notification, {root: true})
          // context.commit('updateResponse', {msg: error, was_good: false});
             // auto-comment// console.log(error);
        });
    },
  }

};

export default Form;